import {
  ASSISTANT_COMMERCIAL,
  COMMERCIAL,
  DIRECTEUR_COMMERCIAL,
} from '@/configuration/parametrage/utilisateurConf';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import store from '@/store/store';

function changeCritereWithUserRole(critere, field, user, role) {
  if (!Array.isArray(role)) return;
  if (critere[field] !== undefined) {
    if (role.includes(user.profil) && critere[field] === null) {
      critere[field] = [user.id];
    } else {
      critere[field] = critere[field] ?? [];
    }
  }
}

export default
async function updateCritereWithParametreInterne(critereRecherche, userProfil, tiersId) {
  if (tiersId) critereRecherche.tiersId.push(tiersId);

  let user = userProfil;
  if (!user) user = store.getters['user/user'];
  await store.dispatch('parametres/loadParametresInterne', [PARAMETRES_INTERNE_KEYS.filtrerAutoParUtilisateur.key]);
  const filtreParUtilisateurConnecte = store.getters['parametres/parametresInterne'](PARAMETRES_INTERNE_KEYS.filtrerAutoParUtilisateur.key);
  changeCritereWithUserRole(critereRecherche, 'commercialId', user, filtreParUtilisateurConnecte ? [COMMERCIAL, DIRECTEUR_COMMERCIAL] : []);
  changeCritereWithUserRole(critereRecherche, 'commercialIds', user, filtreParUtilisateurConnecte ? [COMMERCIAL, DIRECTEUR_COMMERCIAL] : []);
  changeCritereWithUserRole(critereRecherche, 'assistantId', user, filtreParUtilisateurConnecte ? [ASSISTANT_COMMERCIAL] : []);
  changeCritereWithUserRole(critereRecherche, 'assistantIds', user, filtreParUtilisateurConnecte ? [ASSISTANT_COMMERCIAL] : []);
}
